import axios from 'axios';
import request from 'utils/http';
import Apis from 'constants/api';
import _forEach from 'lodash/forEach';
import { startLoading, stopLoading } from 'service/loader/action';
import _get from 'lodash/get';
import actionType from './actionTypes';
import Icons from 'constants/icons';
import { fileDownload } from 'utils/index';
import { showWarning, showSuccess, showError } from 'service/notifications/action';
import { v4 as uuidv4 } from 'uuid';
import { getTradesChartData } from '../refdata/blocdataexplorer/action';

export const getTableMetaProperties =
    (payload = {}) =>
    (dispatch) => {
        dispatch(startLoading());
        request
            .get(Apis.infiniteTableProperties.tableMetaProperties, { params: payload })
            .then(({ data: { data } }) => {
                dispatch({
                    type: actionType.GET_TABLE_META_PROPERTIES_SUCCESS,
                    payload: data,
                });
                dispatch(stopLoading());
            })
            .catch((error) => {
                dispatch(showWarning(`Table Not Found,`, Icons.thumbsUp));
                dispatch(stopLoading());
            });
    };

export const getRowPaginationRecords = async (payload) => {
    return await request
        .post(Apis.infiniteTableProperties.tableInfiniteExtract, payload)
        .then(({ data: { data } }) => data)
        .catch((error) => []);
};

export const exportAllData = (explorerName, infiniteExtractPayload) => (dispatch) => {
    dispatch(startLoading());
    request
        .post(
            Apis.infiniteTableProperties.exportAll,
            {
                explorerName,
                infiniteExtractPayload,
            },
            {
                responseType: 'blob',
            },
        )
        .then(({ data }) => {
            fileDownload(data, `export.xlsx`);
            dispatch(stopLoading());
        })
        .catch((error) => {
            dispatch(showWarning(`Unable to Filter Record's ,`, Icons.thumbsUp));
            dispatch(stopLoading());
        });
};

export const cleanViewData = () => (dispatch) => {
    dispatch({
        type: actionType.CLEAN_EXPLORER_VIEWS,
        payload: [],
    });
};

export const createVirtualColumns = (explorerName, payload, gridApi, isGcTable, updationModal) => (dispatch) => {
    dispatch(startLoading());
    request
        .post(Apis.infiniteTableProperties.virtualColumns, {
            explorerName,
            payload,
            isGcTable,
        })
        .then(({ data: { data } }) => {
            // gridApi.refreshServerSide({purge: true})
            const getPayload = {
                groupName: explorerName,
                isGcTable,
                origin: payload.origin,
            };
            updationModal();
            dispatch(getVirtualColumnViews(getPayload));
            dispatch(showSuccess('Virtual column updated successfully'));
            if (explorerName === 'Trades') {
                dispatch(getTradesChartData());
            }
            dispatch(stopLoading());
        })
        .catch(({ response }) => {
            const error = _get(response.data, 'error', null);
            if (error) {
                const { message } = error;
                if (message.original) dispatch(showError('Incorrect expression. Column not saved', Icons.thumbsDown));
            } else {
                dispatch(showError('Unable to Create View , Please Enter Valid data', Icons.thumbsDown));
            }
            dispatch(stopLoading());
        });
};

export const getVirtualColumnViews = (payload) => (dispatch) => {
    dispatch(startLoading());
    request
        .post(Apis.infiniteTableProperties.virtualColumnsData, payload)
        .then(({ data: { data } }) => {
            dispatch({
                type: actionType.GET_VIEW_RECORDS_SUCCESS,
                payload: data,
            });
            dispatch(stopLoading());
        })
        .catch((error) => {
            console.log(error);
            dispatch(showWarning(`Unable to Fetch Record's ,`, Icons.thumbsUp));
            dispatch(stopLoading());
        });
};

export const cleanVirtualColumns = () => (dispatch) => {
    dispatch({
        type: actionType.GET_VIEW_SUCCESS,
        payload: [],
    });
};

export const setGcLinkedData = (payload) => (dispatch) => {
    dispatch({
        type: actionType.SET_LINKED_DATA,
        payload,
    });
};

/**
 * @param {File} file
 * @returns {Blob[]}
 */
function chunkify(file) {
    /** @type {Blob[]} */
    const chunks = [];
    /** @type {number} file size in bytes */

    const ONE_KILO_BYTE = 1024;
    const chunkSize = 50 * ONE_KILO_BYTE * 1024;
    let start = 0;
    let end = chunkSize;
    while (start <= file.size) {
        const chunk = file.slice(start, end, file.type);
        chunks.push(chunk);
        start = end;
        end += chunkSize;
    }
    return chunks;
}

export const moveFileToServerPath = async (files, filePath, setProgress, setFileNo) => {
    try {
        let fileNo = 1;
        for (const file of files) {
            setProgress(0);
            setFileNo(fileNo);
            fileNo++;
            const chunks = chunkify(file);
            const fileId = uuidv4();
            let idx = 1;
            for (const chunk of chunks) {
                const formData = new FormData();
                formData.append('file', chunk);
                formData.append('fileName', idx);
                formData.append('fileId', fileId);
                formData.append('mimeType', chunk.type);
                formData.append('chunkCount', chunks.length);
                formData.append('filePath', filePath);
                formData.append('name', file.name);
                // Make an HTTP POST request to the server endpoint
                await request
                    .post(Apis.infiniteTableProperties.uploadChunks, formData, {
                        onUploadProgress: (data) => {
                            //Set the progress value to show the progress bar
                            setProgress(Math.round((100 * data.loaded) / data.total));
                        },
                    })
                    .then(() => {
                        return true;
                    })
                    .catch(() => {
                        return false;
                    });
                idx++;
            }
        }
        return true;
    } catch (error) {
        console.log(error);
        return false;
    }
};

export const getFilesFromServer = () => (dispatch) => {
    dispatch(startLoading());
    request
        .get(Apis.infiniteTableProperties.moveFiles)
        .then(({ data: { data } }) => {
            dispatch({
                type: actionType.GET_FILES_FROM_SERVER,
                payload: data,
            });
            dispatch(showSuccess('files fetched'));
            dispatch(stopLoading());
        })
        .catch(({ response: { data } }) => {
            const error = _get(data, 'data', null);
            if (error) {
                const { message } = error;
                dispatch(showError(error, Icons.thumbsDown));
            } else {
                dispatch(showError('Unable to Create View , Please Enter Valid data', Icons.thumbsDown));
            }
            dispatch(stopLoading());
        });
};

export const createFolderInContainer = (folderName, path) => (dispatch) => {
    dispatch(startLoading());
    request
        .post(Apis.infiniteTableProperties.createFolder, { folderName })
        .then(({ data: { data } }) => {
            dispatch(showSuccess('Folders Created Successfully'));
            dispatch(getFilesFromContainerPath({ path }));
            dispatch(stopLoading());
        })
        .catch(({ response: { data } }) => {
            const error = _get(data, 'data', null);
            if (error) {
                const { message } = error;
                dispatch(showError(error, Icons.thumbsDown));
            } else {
                dispatch(showError('Unable to Create Folder , Please Enter Valid data', Icons.thumbsDown));
            }
            dispatch(stopLoading());
        });
};

export const getFilesFromContainerPath = (payload) => (dispatch) => {
    dispatch(startLoading());
    request
        .get(Apis.infiniteTableProperties.showFiles, { params: payload })
        .then(({ data: { data } }) => {
            dispatch({
                type: actionType.GET_FILES_FROM_CONTAINER,
                payload: data,
            });
            dispatch(stopLoading());
        })
        .catch(({ response: { data } }) => {
            const error = _get(data, 'data', null);
            if (error) {
                const { message } = error;
                dispatch(showError(error, Icons.thumbsDown));
            } else {
                dispatch(showError('Unable to Create View , Please Enter Valid data', Icons.thumbsDown));
            }
            dispatch(stopLoading());
        });
};

export const downloadFilesFromServer = (fileName) => (dispatch) => {
    dispatch(startLoading());
    const fileType = fileName.split('.').pop();
    request
        .post(
            Apis.infiniteTableProperties.downloadFiles,
            {
                fileName,
            },
            {
                responseType: 'blob',
            },
        )
        .then(({ data }) => {
            console.log(data, 'data');
            fileDownload(data, `${fileName}`);
            dispatch(stopLoading());
        })
        .catch(({ response: { data } }) => {
            const error = _get(data, 'data', null);
            if (error) {
                const { message } = error;
                dispatch(showError(error, Icons.thumbsDown));
            } else {
                dispatch(showError('Unable to Create View , Please Enter Valid data', Icons.thumbsDown));
            }
            dispatch(stopLoading());
        });
};

export const deleteFileFromContainer = (payload) => (dispatch) => {
    dispatch(startLoading());
    request
        .delete(Apis.infiniteTableProperties.moveFiles, {
            params: {
                ...payload,
            },
        })
        .then(({ data: { data } }) => {
            dispatch(stopLoading());
            dispatch(showSuccess(`File Deleted successfully`, Icons.thumbsUp));
            dispatch(getFilesFromContainerPath(payload));
        })
        .catch((error) => {
            dispatch(showWarning(`Unable to Delete File/Folder`, Icons.thumbsDown));
            dispatch(stopLoading());
        });
};

export const getChatBotResponse = (question) => request.post(Apis.refData.apiChatBot, { question });
export const raiseIssue = (payload, setMessages) => (dispatch) => {
    console.log(payload);
    dispatch(startLoading());
    request
        .post(Apis.refData.apiRaiseIssue, payload)
        .then(({ data: { data } }) => {
            dispatch(stopLoading());
            dispatch(showSuccess('Issue created successfully'));
            setMessages(data);
        })
        .catch((err) => {
            dispatch(stopLoading());
            dispatch(showWarning('Unable to raise ticket'));
        });
};
